<template>
  <footer>
    <div class="code-api">
      <el-image class="code-api-fic"
                :src="codeApiImage"
                fit="fill"></el-image>
      <div class="code-title">创建我的地理编码功能</div>
      <router-link to="/support/geo"><button class="yello-btn">创建地理编码API</button></router-link>
    </div>
    <bottom-footer />
  </footer>
</template>
<script>
import BottomFooter from '@/views/home/BottomFooter.vue';
export default {
  data() {
    return {
      codeApiImage: require('@/assets/img/code-function.png')
    };
  },
  components: {
    BottomFooter
  }
};
</script>
<style lang="less" scoped>
.code-api {
  height: 235px;
  position: relative;
  .code-api-fic {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .code-title {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    font-family: PingFangSC-Semibold;
    font-size: 32px;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    line-height: 45px;
  }
  .yello-btn {
    background: #ffd100;
    border-radius: 100px;
    width: 185px;
    height: 42px;
    font-size: 18px;
    color: #000;
    font-weight: 600;
    line-height: 25px;
    padding: 9px 0;
    letter-spacing: 0;
    position: absolute;
    top: 138px;
    left: 50%;
    transform: translateX(-50%);
    border: none;
    cursor: pointer;
  }
}
</style>
